<template>
    <div class="checkbox" :class="{saved: savedFields.hasOwnProperty(name) && !changed}">
        <v-checkbox v-model="item[name]" @change="changed = true" :label="title"></v-checkbox>
    </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'

  const { mapMutations, mapState } = createNamespacedHelpers('editPage')
  export default {
    name: "Checkbox",
    data() {
      return {
        changed: false
      }
    },
    props: [
      'name',
      'title'
    ],
    computed: {
      ...mapState([
        'item',
        'savedFields'
      ])
    },
  }
</script>

<style scoped>
  .saved {
    padding: 5px;
    border-radius: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/components/edit-form/Checkbox.vue